import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AdminService } from './admin.service';
import { CoreService } from '../core/core.service';
import { Router } from '@angular/router';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})

export class ActivitiesComponent {

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  activities: any[];
  selectedUser: any = {};
  activityForm!: FormGroup;
  imageUrl: any;
  selectedActivityUrl: any;

  constructor(private api: AdminService, private router: Router, private formBuilder: FormBuilder, private sanitizer: DomSanitizer, private coreService: CoreService, private mainService: Main, @Inject(Restangular) public Restangular) {
    this.filter = '';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.getActivityFilter('');
  }

  get user() { return this.activityForm.get('user'); }
  get status() { return this.activityForm.get('status'); }
  get remark() { return this.activityForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getActivityFilter("");
  }

  private createForm() {

    this.activityForm = this.formBuilder.group({
      user: ['', [Validators.required,]],
      status: ['active', Validators.required],
      remark: [''],
    });
  }


  getActivityFilter(filter: any) {
    this.filter = filter;
    this.getActivities();
  }

  getActivities() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getActivities(this.currentPage, this.filter).subscribe((resp: any) => {
      this.activities = resp.data;
      for (let i = 0; i < this.activities.length; i++) {
        this.activities[i].imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.activities[i].avatar}`);
        this.activities[i].legalIdUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.activities[i].legal_id}`);
        this.activities[i].no = j + 1;
        j++;
      }
      console.log(this.activities);
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    });
  }

  /*   setActivite(activity: any) {
      debugger;
      this.selectedActivity = activity;
  
    } */

  setActivityUrl(activity: any = null) {
    debugger;
    if (activity != null) this.selectedActivityUrl = activity;
  }

  changeStatus(id: any, status: any) {
    this.api.changeUserStatus(id, status).subscribe((res: any) => {
      //this.coreService.addToast('Success', res.data.title);
      this.getActivities();
    }, (err: any) => {
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getActivities();
  }

}
